import type { TSectionApplianceCategory } from "#/ui-kit/components/section/appliances/section-appliance-category.types";
import type { TranslationKey } from "@voltalis/frontend-tooling/i18n/runtime";

import { EOtherApplianceCategory } from "#/ui-kit/components/section/appliances/section-appliance-category.types";
import { useCommonFrontendIntl } from "#/ui-kit/locales/typed-intl";

export function getCategoryTranslationKey(category: TSectionApplianceCategory): TranslationKey {
  const { k } = useCommonFrontendIntl();

  if (category === EOtherApplianceCategory.OTHER) {
    return k.commonFrontend.misc.other;
  }

  return k.commonFrontend.applianceCategory[category];
}
